export function toLocaleStringWithDecimals(value: string | number, decimals = 2): string {
  const numberWithCommas = Number(value).toLocaleString();
  const numberWithDecimals = Number(value).toFixed(decimals);
  return `${numberWithCommas.split('.')[0]}.${numberWithDecimals.slice(-decimals)}`;
}
